/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useCallback, useContext, useState } from "react";
import debounce from "lodash.debounce";
import { ImageInPageEditorV2 } from "cms/images/image-inpage-editor-v2";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import { isStringEmpty } from "utils/empty-exists";
import { Logger } from "cms/utils/log/logger";
// import { useCurrentDynamicField } from 'cms/fields/dynamic-field'
// import useThrottle from 'hooks/useThrottle'

const ImageFieldItemEdit = () => {
    
    const { index, value: image, settings, updateListItem } =  useContext(ListItemContext);
    const [itemLocalState, setItemLocalState] = useState({ value: image, settings });
    // FIXME: hardcoded default settings for now
    const defaultImageSettings = {
        style: "field.style.none",
        format: "field.format.cover",
        options: {
            "position": "center center",
            "target": "new"
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 500),
        [updateListItem]
    );
    
    const onChangeImageWithSettings = (image, settings) => {
        const { guid } = image || {};
        if (isStringEmpty(guid)) {
            Logger.warn("[onChangeImageWithSettings] image guid missing", { image, guid });
        } else {
            const newImage = guid;
            // FIXME: field settings are validated at the api
            // FIXME: field settings are different from components etc. have "style", "format"
            // FIXME: hardcoded default settings for now
            //    do transform ?
            Logger.info(settings);
            const updatedState = {
                ...itemLocalState,
                value: newImage,
                // settings: settings ?? defaultImageSettings
                settings: defaultImageSettings
            };
            setItemLocalState(updatedState);
            update(updatedState, index);
        }
    };
    // const onChangeSettings = (settings) => {
    //     const updatedState = {
    //         ...itemLocalState,
    //         settings: settings
    //     }
    //     setItemLocalState(updatedState)
    //     update(updatedState, index)
    // }
    
    const onRemoveImage = () => {
        const updatedState = {
            ...itemLocalState,
            value: "",
            settings: settings
        };
        setItemLocalState(updatedState);
        update(updatedState, index);
    };
    
    return (
        <Fragment>
            <div className='simplicity-composer-field-primary-layout'>
                <ImageInPageEditorV2
                    image_guid={image}
                    settings={settings}
                    onChangeImageWithSettings={onChangeImageWithSettings}
                    onRemoveImage={onRemoveImage}
                />
            </div>
            {/*<pre>*/}
            {/*    {JSON.stringify(itemLocalState, null, 2)}*/}
            {/*</pre>*/}
        </Fragment>
    );
};
export default ImageFieldItemEdit;
